var GridMonitorSerialnumberComponent = /** @class */ (function () {
    function GridMonitorSerialnumberComponent() {
    }
    GridMonitorSerialnumberComponent.prototype.agInit = function (params) {
        this.monitor = params.data;
    };
    return GridMonitorSerialnumberComponent;
}());
export { GridMonitorSerialnumberComponent };
